module.exports = __webpack_public_path__ + "img/activities-slogan.a02f7f34.png";